const state = {
  items: [
    /*
    id: String,
    message: String,
    type: String [error, success, notification (default)]
    */
  ]
}

const mutations = {
  items: (state, payload) => {
    state.items = payload
  }
}

const actions = {
  push: ({ state, commit }, payload) => {
    const items = [...state.items]
    if (items.find((a) => a.id === payload.id)) {
      return
    }
    items.push(payload)
    commit("items", items)
  },

  pop: ({ state, commit }, payload) => {
    let items = [...state.items]
    items = items.filter((a) => a.id !== payload)
    commit("items", items)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
